import React from 'react';
import './styles/Pricing.css';
import priceGE from './images/light GE.png'
import { Link } from 'react-router-dom'; 
function Pricing() {
  return (
    <div className="pricing-container">
      <h2 className="pricing-title">Packages and Pricing</h2>
      <div className="packages">
        {/* Podcast Package */}
        <div className="package-card">
          <h3 className="package-title">Podcast Package</h3> <hr className='styled-hr'  />
          <div className="package-price">$40 <span> <strong>/</strong> HR</span> </div>
          <p className="package-description">Complete Podcast Editing Package</p>
          <ul className="package-features">
            <div className="podcast-1st">  <span class="checkmark basic-checkmark" >&#10003;</span> 
            <li> Delete unwanted parts (uhms, repeats, filler words etc.)</li>
            </div>
        
            <div className="podcast-1st"><span class="checkmark basic-checkmark" >&#10003;</span> 
            <li> Normalize/Leveling the volume</li>
            </div>
            
            <div className="podcast-1st">  <span class="checkmark basic-checkmark" >&#10003;</span> 
            <li> Removal of Echo, Background, and other heavy mouth Noises, etc.</li>
            </div>
          
            <div className="podcast-1st"> <span class="checkmark basic-checkmark" >&#10003;</span> 
            <li> Add Background Music and sound effects (provided)</li>
            </div>
           
            <div className="podcast-1st">    <span class="checkmark basic-checkmark" >&#10003;</span> 
            <li> Add your intro and outro and deliver mp3 or any other format you want.</li>
        </div>
          </ul>
          <Link to="/contact">
            <button className="package-button">Get started</button>
          </Link>
        </div>

        {/* Premium Package */}
        <div className="package-card most-popular">
          <div className="most-popular-tag">Most Popular 🌟</div>
          <h3 className="package-title">Premium Package</h3> <hr className='styled-hr'  />
          <div className="package-price">$50 <span><strong>/</strong> HR</span></div>
          <p className="package-description">Complete Audiobook Editing & Mastering Package</p>
          <ul className="package-features">
            <div className="premium-checkmark">
            <span class="checkmark checkmark-premium" >&#10003;</span> 
            <li> Everything in Basic Package</li>

            </div>
            <div className="premium-checkmark">
            <span class="checkmark checkmark-premium" >&#10003;</span> 
            <li> Removal of Extraneous </li>
            </div>
            <ul > <li className='inter-ul'>Background and Mouth Noises (Clicks, Plosives, Pops etc.)</li>
              <li className='inter-ul'> Repeats, bad takes and mistakes</li></ul>
            
            
            
            <div className="premium-checkmark">
            <span class="checkmark checkmark-premium-below" >&#10003;</span> 
            <li> Manual Breath Control and space adjustments to ensure smooth flow.</li>
          
            </div>
           
            <div className="premium-checkmark">  
            <span class="checkmark checkmark-premium-below" >&#10003;</span> <li> Proofing the audio with the script.</li>
            </div>
         </ul>
         <div className="pkgbtn-2">   
         <Link to="/contact">
            <button className="package-button">Get started</button>
          </Link>
         </div>
        </div>

        {/* Basic Package */}
        <div className="package-card">
          <h3 className="package-title">Basic Package</h3> <hr className='styled-hr' />
          <div className="package-price">$10 <span><strong>/</strong> HR</span></div>
          <p className="package-description">Audiobook Mastering Package</p>
          <ul className="package-features ">
            <div className="third">
            <span class="checkmark basic-checkmark" >&#10003;</span> 
            <li >Fixing/Checking and mastering Audiobooks for:</li></div>
          <ul className=' package-3' >  <li>RMS, Peak Level, Noise Floor, Spacing</li>
            <li>Title discrepancy across the cover/audio credits/metadata</li>
            <li>Writing contains interlacing and much more..!</li></ul>
          
          </ul>
          <div className="pkgbtn-3">   
          <Link to="/contact">
            <button className="package-button">Get started</button>
          </Link>
         </div></div>
      </div>
      <div className="img-bg1"><img src={priceGE} alt="" /></div>
      <div className="img-bg2"><img src={priceGE} alt="" /></div>
    </div>
  );
}

export default Pricing;
